import { getCurrentUser } from 'aws-amplify/auth';
import { redirect } from 'react-router';

import { loginRedirectURL } from 'utils/auth';

import { dedupedFetchAuthSession } from './api';

export async function getSession() {
  await getCurrentUser();
  const session = await dedupedFetchAuthSession();
  return session;
}

export async function requireUser(request: Request) {
  try {
    return getCurrentUser();
  } catch {
    const url = new URL(request.url);
    throw redirect(loginRedirectURL(url));
  }
}
